import React from 'react'
import moment from 'moment';
import { imagepath } from '../../Repository/BaseUrl';
import { LeaveView } from './FinancialYear';
const OverallReport = ({ appliedReport, isOldReportYear, apply }) => {
  
  return (
    <div className="mt-5">
      {(apply?.employee_ids?.length === 1 && apply?.employee_ids[0]?.label !== "All" || !apply?.employee_ids) &&
        <>
          <p className='text-center fw-bold' >GENERAL INFORMATION</p>
          <table className="gen-table-content mx-auto">
            <tr>
              <td>1. Name</td>
              <td>: {appliedReport?.name}</td>
            </tr>

            <tr>
              <td>2. Date of Birth</td>
              <td>: {moment(appliedReport?.dob).format("DD-MM-yyyy")}</td>
            </tr>
            <tr>
              <td>3. Father's Name</td>
              <td>: {appliedReport?.father_name}</td>
            </tr>
            <tr>
              <td>4. Name of the Department / Centre / Extension Centre</td>
              <td>: {appliedReport?.department}</td>
            </tr>
            <tr>
              <td>5. Current Designation & Scale of Pay</td>
              <td>: {appliedReport?.designation}</td>
            </tr>
            <tr>
              <td>6. Academic Qualification obtained during the Assessment Period</td>
              <td>: {appliedReport?.academic_qualification?.map((item, i) => (item?.qualification)).join('.,')}</td>
            </tr>
            <tr>
              <td>7. Period of absence from duty during the year (Leave)</td>
              <td>: {appliedReport?.period_of_absence?.length > 0 ? LeaveView(appliedReport?.period_of_absence) : '-'}</td>
            </tr>
          </table>
        </>
      }

      {(appliedReport?.non_sponsored_training?.length > 0 || appliedReport?.non_sponsored_training?.length > 0 || appliedReport?.skill_development?.length > 0 || appliedReport?.development_of_moocs?.length > 0 || appliedReport?.resource_person?.length > 0 || appliedReport?.development_of_training_manual?.length > 0 || appliedReport?.courses_handled_for_pg_phd?.length > 0 || appliedReport?.new_courses_developed_offered?.length > 0 || appliedReport?.curriculum_developed_or_revised?.length > 0) &&
        <p className='text-center mt-5 fw-bold'>ACADEMIC CONTRIBUTIONS</p>
      }
      {appliedReport?.non_sponsored_training?.length > 0 && (
        <div>
          <h6 className="reporttitle">
            a. Grant in aid Training Programmes to be conducted as Coordinator :
          </h6>
          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">{isOldReportYear ? "FDP.No" : "PDP.No"}</th>
                  <th scope="col">Mode</th>
                  <th scope="col">Conducted at</th>
                  <th scope="col">
                    Duration
                    <table className="table">
                      <tr>
                        <td className='w-8'>From</td>
                        <td className='w-8'>To</td>
                      </tr>
                    </table>
                  </th>
                  <th scope="col">No.of Hours Handled</th>
                  <th scope="col">
                    {isOldReportYear ? "Level" : "Revenue Generated(in Rs)"}
                  </th>
                  <th scope="col">Attachment</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.non_sponsored_training?.map(
                  (nonsponsored, index) => {
                    return (
                      <tr key={nonsponsored.id}>
                        <td>{nonsponsored?.fdp_no}</td>
                        <td className="textformat">
                          {nonsponsored?.mode}
                        </td>
                        <td className="textformat">
                          {nonsponsored?.conducted_at}
                        </td>
                        <td>
                          <table className="table">
                            <tr>
                              <td className='w-8'>
                                {moment(
                                  nonsponsored.from_date
                                ).format("DD-MM-yyyy")}
                              </td>
                              <td className='w-8'>
                                {moment(
                                  nonsponsored.to_date
                                ).format("DD-MM-yyyy")}
                              </td>
                            </tr>
                          </table>
                        </td>
                        <td>{nonsponsored?.no_of_hours}</td>
                        {isOldReportYear ?
                          <td className="textformat">{nonsponsored?.level}</td>
                          :
                          <td className="textformat">{nonsponsored?.revenue_generated}</td>
                        }
                        {nonsponsored?.attachment ? (
                          <td>
                            <span
                              className="namelink"
                              onClick={() => {
                                window.open(
                                  `${imagepath}${nonsponsored?.attachment}`
                                );
                              }}
                              target="_blank"
                            >
                              View Document
                            </span>
                          </td>
                        ) : (
                          <td>No Data</td>
                        )}
                      </tr>
                    );
                  }
                )}
                {!isOldReportYear &&
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Total Generated Revenue</td>
                    <td>
                      {appliedReport?.non_sponsored_training_total_revenue}
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.sponsored_contact_mode?.length > 0 && (
        <div>
          <h6 className="reporttitle">  b. Sponsored Contact mode Training Programmers conducted as Coordinator/ Co-coordinator (Funded by State/Central Government or ITEC) :</h6>
          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Title of the Programme</th>
                  {!isOldReportYear &&
                    <th scope="col">Mode</th>
                  }
                  <th scope="col">Sponsoring Agency</th>
                  <th scope="col">Conducted at</th>
                  <th scope="col">
                    Duration
                    <table className="table">
                      <tr>
                        <td className='w-8'>From</td>
                        <td className='w-8'>To</td>
                      </tr>
                    </table>
                  </th>
                  <th scope="col">Role</th>
                  <th scope="col">
                    No.of Hours <br /> Handled
                  </th>
                  <th scope="col">Level</th>
                  <th scope="col">
                    Amount of Grant <br /> (Rs. in Lakhs)
                  </th>
                  <th scope="col">Attachment</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.sponsored_contact_mode?.map((sponsored, index) => {
                  return (
                    <tr key={sponsored.id}>
                      <td className="textformat">{sponsored?.title}</td>
                      {!isOldReportYear &&
                        <td className="textformat">{sponsored?.mode}</td>
                      }
                      <td className="textformat">{sponsored?.sponsored_agency}</td>
                      <td className="textformat">{sponsored?.conducted_at}</td>
                      <td>
                        <table className="table">
                          <tr>
                            <td className='w-8'>{moment(sponsored.from_date).format("DD-MM-yyyy")}</td>
                            <td className='w-8'>{moment(sponsored.to_date).format("DD-MM-yyyy")}</td>
                          </tr>
                        </table>
                      </td>
                      <td className="textformat">{sponsored?.role}</td>
                      <td>{sponsored?.no_of_hours}</td>
                      <td className="textformat">{sponsored?.level}</td>
                      <td>{sponsored?.amount}</td>
                      {sponsored?.attachment ? (
                        <td>
                          <span
                            className="namelink"
                            onClick={() => {
                              window.open(`${imagepath}${sponsored?.attachment}`);
                            }}
                            target="_blank"
                          >
                            View Document
                          </span>
                        </td>
                      ) : (
                        <td>No Data</td>
                      )}
                    </tr>
                  );
                })}
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  {!isOldReportYear && <td></td>}
                  <td></td>
                  <td>Total Grants Received</td>
                  <td>
                    {appliedReport?.total_amount_recieved_for_sponsored_contact_mode}
                  </td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.skill_development?.length > 0 && (
        <div>
          <h6 className="reporttitle">c. Skill Development / Industrial Training Programmers conducted as Coordinator/ Co-coordinator :</h6>
          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Title of the Programme</th>
                  <th scope="col">Sponsoring Agency</th>
                  <th scope="col">Conducted at</th>
                  <th scope="col">
                    Duration
                    <table className="table">
                      <tr>
                        <td className='w-8'>From</td>
                        <td className='w-8'>To</td>
                      </tr>
                    </table>
                  </th>
                  <th scope="col">Role</th>
                  <th scope="col">
                    No.of Hours <br /> Handled
                  </th>
                  {isOldReportYear &&
                    <th scope="col">Level</th>
                  }
                  <th scope="col">
                    Amount of Grant <br /> (Rs. in Lakhs)
                  </th>
                  <th scope="col">Attachment</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.skill_development?.map((sponsored, index) => {
                  return (
                    <tr key={sponsored.id}>
                      <td className="textformat">{sponsored?.title}</td>
                      <td className="textformat">{sponsored?.sponsored_agency}</td>
                      <td className="textformat">{sponsored?.conducted_at}</td>
                      <td>
                        <table className="table">
                          <tr>
                            <td className='w-8'>{moment(sponsored.from_date).format("DD-MM-yyyy")}</td>
                            <td className='w-8'>{moment(sponsored.to_date).format("DD-MM-yyyy")}</td>
                          </tr>
                        </table>
                      </td>
                      <td className="textformat">{sponsored?.role}</td>
                      <td>{sponsored?.no_of_hours}</td>
                      {isOldReportYear &&
                        <td className="textformat">{sponsored?.level}</td>
                      }
                      <td>{sponsored?.amount}</td>
                      {sponsored?.attachment ? (
                        <td>
                          <span
                            className="namelink"
                            onClick={() => {
                              window.open(`${imagepath}${sponsored?.attachment}`);
                            }}
                            target="_blank"
                          >
                            View Document
                          </span>
                        </td>
                      ) : (
                        <td>No Data</td>
                      )}
                    </tr>
                  );
                })}
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  {isOldReportYear ?
                    <td></td> : ''
                  }
                  <td>Total Grants Received</td>
                  <td>{appliedReport?.total_amount_recieved_for_skill_development}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.development_of_moocs?.length > 0 && (
        <div>
          <h6 className="reporttitle">        d. Development/offer of MOOCs / MMLPs as Coordinator / Co-coordinator or minimum 30 min video lectures / Educational video films :</h6>
          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">
                    Title of the MOOC / MMLP / 30 min video
                    <br />
                    lectures / Educational video films
                  </th>
                  <th scope="col">{isOldReportYear ? 'Date of Launch' : 'Status'}</th>
                  {!isOldReportYear ?
                    <th scope="col">
                      Duration
                      <table className="table">
                        <tr>
                          <td className='w-8'>From</td>
                          <td className='w-8'>To</td>
                        </tr>
                      </table>
                    </th> : ''}
                  <th scope="col">Time</th>
                  <th scope="col">Platform</th>
                  <th scope="col">Coordinator / Co-Coordinator</th>
                  <th scope="col">Used for</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.development_of_moocs?.map((develop, index) => {
                  return (
                    <tr key={develop.id}>
                      <td className="textformat">{develop?.title}</td>
                      <td>
                        {isOldReportYear ? moment(develop.date_of_launch).format("DD-MM-yyyy") : develop.status}
                      </td>
                      {!isOldReportYear &&
                        <td>
                          <table className="table">
                            <tr>
                              <td className='w-8'>{moment(develop.from_date).format("DD-MM-yyyy")}</td>
                              <td className='w-8'>{moment(develop.to_date).format("DD-MM-yyyy")}</td>
                            </tr>
                          </table>
                        </td>
                      }
                      <td className="textformat">{develop?.time_taken}</td>
                      <td className="textformat">{develop?.platform}</td>
                      <td className="textformat">{develop?.coordinator_or_co_coordinator}</td>
                      <td className="textformat">{develop?.used_for}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.resource_person?.length > 0 && (
        <div>
          <h6 className="reporttitle"> e. Resource person in Training Programmes (Institute) :</h6>
          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">{isOldReportYear ? 'FDP.No' : "Course Number"}</th>
                  {!isOldReportYear ? <th scope="col">Course Type</th> : ""}
                  <th scope="col">Mode</th>
                  <th scope="col">Conducted at</th>
                  <th scope="col">
                    Duration
                    <table className="table">
                      <tr>
                        <td className='w-8'>From</td>
                        <td className='w-8'>To</td>
                      </tr>
                    </table>
                  </th>
                  <th scope="col">No.of Hours Handled</th>
                  {isOldReportYear ? <th scope="col">Level</th> : ""}
                </tr>
              </thead>
              <tbody>
                {appliedReport?.resource_person?.map((resource, index) => {
                  return (
                    <tr key={resource.id}>
                      <td>{resource?.fdp_no}</td>
                      {!isOldReportYear && <th>{resource?.course_type}</th>}
                      <td className="textformat">{resource?.mode}</td>
                      <td className="textformat">{resource?.conducted_at}</td>
                      <td>
                        <table className="table">
                          <tr>
                            <td className='w-8'>{moment(resource.from_date).format("DD-MM-yyyy")}</td>
                            <td className='w-8'>{moment(resource.to_date).format("DD-MM-yyyy")}</td>
                          </tr>
                        </table>
                      </td>
                      <td>{resource?.no_of_hours}</td>
                      {isOldReportYear &&
                        <td className="textformat">{resource?.level}</td>
                      }
                    </tr>
                  );
                })}
                <tr>
                  <td></td>
                  <td></td>
                  {!isOldReportYear &&
                    <td></td>}
                  <td></td>
                  <td>Total Number of hours handled</td>
                  <td>{appliedReport?.total_no_of_hours_for_resource_person}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.development_of_training_manual?.length > 0 && (
        <div>
          <h6 className="reporttitle">  f. Development of Training / Laboratory Manuals:</h6>
          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Author (s) Name in order as appeared</th>
                  <th scope="col">Title</th>
                  <th scope="col">Type of publications</th>
                  <th scope="col">Publisher Country</th>
                  <th scope="col">Publisher Year</th>
                  <th scope="col">Total Pages</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.development_of_training_manual?.map((development, index) => {
                  return (
                    <tr key={development.id}>
                      <td className="textformat">{development?.author_name}</td>
                      <td className="textformat">{development?.title}</td>
                      <td className="textformat">{development?.type_of_publications}</td>
                      <td className="textformat">{development?.publisher_country}</td>
                      <td>{development?.publisher_year}</td>
                      <td>{development?.total_pages}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.courses_handled_for_pg_phd?.length > 0 && (
        <div>
          <h6 className="reporttitle">g. Courses handled for PG / Ph.D. Programme :</h6>
          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Course Number and Title</th>
                  <th scope="col">Degree</th>
                  <th scope="col">Type of Subject</th>
                  <th scope="col">Credit</th>
                  {!isOldReportYear &&
                    <th scope="col">
                      Duration
                      <table className="table">
                        <tr>
                          <td className='w-8'>From</td>
                          <td className='w-8'>To</td>
                        </tr>
                      </table>
                    </th>
                  }
                  {isOldReportYear &&
                    <th scope="col">Type of College</th>
                  }
                  <th scope="col">Type</th>
                  {isOldReportYear &&
                    <th scope="col">No.of Hours Handled</th>
                  }
                </tr>
              </thead>
              <tbody>
                {appliedReport?.courses_handled_for_pg_phd?.map((courses, index) => {
                  return (
                    <tr key={courses.id}>
                      <td className="textformat">{courses?.course_number_and_title}</td>
                      <td className="textformat">{courses?.pg_or_phd}</td>
                      <td className="textformat">{courses?.theory_or_laboratory}</td>
                      <td>{courses?.credit}</td>
                      {!isOldReportYear &&
                        <td>
                          <table className="table">
                            <tr>
                              <td className='w-8'>{moment(courses.from_date).format("DD-MM-yyyy")}</td>
                              <td className='w-8'>{moment(courses.to_date).format("DD-MM-yyyy")}</td>
                            </tr>
                          </table>
                        </td>
                      }
                      {isOldReportYear &&
                        <td className="textformat">{courses?.university_or_institute}</td>
                      }
                      <td className="textformat">{courses?.individual_or_shared}</td>
                      {isOldReportYear &&
                        <td>{courses?.no_of_hours}</td>
                      }
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.new_courses_developed_offered?.length > 0 && (
        <div>
          <h6 className="reporttitle">h. New Course(s) developed and offered :</h6>
          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Course Number and title</th>
                  <th scope="col">Degree</th>
                  <th scope="col">Type of Subject</th>
                  <th scope="col">Credit</th>
                  {isOldReportYear &&
                    <th scope="col">Type of College</th>
                  }
                  <th scope="col">Type</th>
                  <th scope="col">{isOldReportYear ? 'No.of times Offered' : 'First Time Offered'}</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.new_courses_developed_offered?.map((newcourses, index) => {
                  return (
                    <tr key={newcourses.id}>
                      <td className="textformat">{newcourses?.course_number_and_title}</td>
                      <td className="textformat">{newcourses?.pg_phd_or_fdp_level}</td>
                      <td className="textformat">{newcourses?.theory_or_laboratory}</td>
                      <td>{newcourses?.credit}</td>
                      {isOldReportYear &&
                        <td className="textformat">{newcourses?.university_or_institute}</td>
                      }
                      <td className="textformat">{newcourses?.individual_or_shared}</td>
                      <td>{isOldReportYear ? newcourses?.no_of_times : newcourses?.first_time_offered}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.curriculum_developed_or_revised?.length > 0 && (
        <div>
          <h6 className="reporttitle">i. Curriculum Developed / Revised :</h6>
          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Role Type</th>
                  {isOldReportYear ?
                    <>
                      <th scope="col">
                        Curriculum Developed
                        <table className="table">
                          <tr>
                            <td>No.of Programs</td>
                            <td>No.of Courses</td>
                          </tr>
                        </table>
                      </th>
                      <th scope="col">
                        Curriculum Revised
                        <table className="table">
                          <tr>
                            <td>No.of Programs</td>
                            <td>No.of Courses</td>
                          </tr>
                        </table>
                      </th>
                    </> :
                    <>
                      <th scope="col">Curriculam</th>
                      <th scope="col">No. of Courses</th>
                    </>
                  }
                  <th scope="col">Amount (Rs. in Lakhs)</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.curriculum_developed_or_revised?.map((curriculum, index) => {
                  return (
                    <tr key={curriculum.id}>
                      <td className="textformat">{curriculum?.client}</td>
                      {isOldReportYear ?
                        <>
                          <td>
                            <table className="table">
                              <tr>
                                <td>{curriculum?.curriculum_developed?.no_of_programs}</td>
                                <td>{curriculum?.curriculum_developed?.no_of_courses}</td>
                              </tr>
                            </table>
                          </td>
                          <td>
                            <table className="table">
                              <tr>
                                <td>{curriculum?.curriculum_revised?.no_of_programs}</td>
                                <td>{curriculum?.curriculum_revised?.no_of_courses}</td>
                              </tr>
                            </table>
                          </td>
                        </> :
                        <>
                          <td>{curriculum?.developed_or_revised}</td>
                          <td>{curriculum?.no_of_courses}</td>
                        </>
                      }
                      <td>{curriculum?.amount}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {(appliedReport?.phd_research_guidances?.length > 0 || appliedReport?.post_graduate_thesis_guidances?.length > 0 || appliedReport?.sponsored_research_projects?.length > 0 || appliedReport?.consultancy_works_carried_out?.length > 0 || appliedReport?.research_publications?.length > 0 || appliedReport?.papers_presentation?.length > 0 || appliedReport?.books_authored?.length > 0 || appliedReport?.patents?.length > 0 || appliedReport?.awards_details?.length > 0) &&
        <p className='text-center mt-5 fw-bold'>RESEARCH CONTRIBUTIONS</p>
      }

      {appliedReport?.phd_research_guidances?.length > 0 && (
        <div>
          <h6 className="reporttitle">a. Ph.D. research scholars guided :</h6>
          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Name of Ph.D. Students</th>
                  <th scope="col">Title of thesis</th>
                  <th scope="col">NITTTR / Affiliating University</th>
                  <th scope="col">Year of Completion</th>
                  <th scope="col">Staff</th>
                  <th scope="col">Attachment</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.phd_research_guidances?.map((nonsponsored, index) => {
                  return (
                    <tr key={nonsponsored.id}>
                      <td className="textformat">{nonsponsored?.name_of_the_student}</td>
                      <td className="textformat">{nonsponsored?.title}</td>
                      <td className="textformat">{nonsponsored?.affiliating_university}</td>
                      <td>{nonsponsored?.year_of_completion}</td>
                      <td className="textformat">{nonsponsored?.supervisor_or_joint_supervisor}</td>
                      {nonsponsored?.attachment ? (
                        <td>
                          <span
                            className="namelink"
                            onClick={() => {
                              window.open(`${imagepath}${nonsponsored?.attachment}`);
                            }}
                            target="_blank"
                          >
                            View Document
                          </span>
                        </td>
                      ) : (
                        <td>No Data</td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.post_graduate_thesis_guidances?.length > 0 && (
        <div>
          <h6 className="reporttitle"> b. Post Graduate thesis guided :</h6>
          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Name of Ph.D. Students</th>
                  <th scope="col">Title of thesis</th>
                  <th scope="col">NITTTR / Affiliating University</th>
                  <th scope="col">Year of Completion</th>
                  <th scope="col">Staff</th>
                  <th scope="col">Attachment</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.post_graduate_thesis_guidances?.map((nonsponsored, index) => {
                  return (
                    <tr key={nonsponsored.id}>
                      <td className="textformat">{nonsponsored?.name_of_the_student}</td>
                      <td className="textformat">{nonsponsored?.title}</td>
                      <td className="textformat">{nonsponsored?.affiliating_university}</td>
                      <td>{nonsponsored?.year_of_completion}</td>
                      <td className="textformat">{nonsponsored?.supervisor_or_joint_supervisor}</td>
                      {nonsponsored?.attachment ? (
                        <td>
                          <span
                            className="namelink"
                            onClick={() => {
                              window.open(`${imagepath}${nonsponsored?.attachment}`);
                            }}
                            target="_blank"
                          >
                            View Document
                          </span>
                        </td>
                      ) : (
                        <td>No Data</td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.sponsored_research_projects?.length > 0 && (
        <div>
          <h6 className="reporttitle">c. Sponsored research projects carried out :</h6>
          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Project Title</th>
                  <th scope="col">Sponsored Agency</th>
                  <th scope="col">
                    Period
                    <table className="table">
                      <tr>
                        <td className='w-8'>From</td>
                        <td className='w-8'>To</td>
                      </tr>
                    </table>
                  </th>
                  {isOldReportYear &&
                    <>
                      <th scope="col">Duration (YY-MM)</th>
                      <th scope="col">Research/Consultancy</th>
                    </>
                  }
                  <th scope="col">PI or Co-PI</th>
                  <th scope="col">Ongoing / Submitted</th>
                  <th scope="col">Amount of Grant(Rs. in Lakhs)</th>
                  <th scope="col">Attachment</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.sponsored_research_projects?.map((sponsoredre, index) => {
                  return (
                    <tr key={sponsoredre.id}>
                      <td className="textformat">{sponsoredre?.title}</td>
                      <td className="textformat">{sponsoredre?.sponsored_agency}</td>
                      <td>
                        <table className="table">
                          <tr>
                            <td className='w-8'>{moment(sponsoredre?.from_date).format("DD-MM-yyyy")}</td>
                            <td className='w-8'>{moment(sponsoredre?.to_date).format("DD-MM-yyyy")}</td>
                          </tr>
                        </table>
                      </td>
                      {isOldReportYear &&
                        <>
                          <td>{sponsoredre?.duration}</td>
                          <td className="textformat">{sponsoredre?.research_consultancy}</td>
                        </>
                      }
                      <td className="textformat">{sponsoredre?.pi_or_co_pi}</td>
                      <td className="textformat">{sponsoredre?.ongoing_or_submitted}</td>
                      <td>{sponsoredre?.amount}</td>
                      {sponsoredre?.attachment ? (
                        <td>
                          <span
                            className="namelink"
                            onClick={() => {
                              window.open(`${imagepath}${sponsoredre?.attachment}`);
                            }}
                            target="_blank"
                          >
                            View Document
                          </span>
                        </td>
                      ) : (
                        <td>No Data</td>
                      )}
                    </tr>
                  );
                })}
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  {isOldReportYear && <td></td>}
                  {isOldReportYear && <td></td>}
                  <td></td>
                  <td>Total Amount of Grant</td>
                  <td>{appliedReport?.total_amount_for_sponsored_research_projects}</td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.consultancy_works_carried_out?.length > 0 && (
        <div>
          <h6 className="reporttitle">d. Consultancy works carried out based On the requirements of the clientele system :</h6>

          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Project Title/Cources Conducted</th>
                  <th scope="col">Sponsored Agency</th>
                  <th scope="col">
                    Period
                    <table className="table">
                      <tr>
                        <td className='w-8'>From</td>
                        <td className='w-8'>To</td>
                      </tr>
                    </table>
                  </th>
                  {isOldReportYear &&
                    <>
                      <th scope="col">Duration (YY-MM)</th>
                      <th scope="col">Research / Consultancy</th>
                    </>
                  }
                  <th scope="col">PI or Co-PI</th>
                  <th scope="col">Amount of Grant(Rs. in Lakhs)</th>
                  <th scope="col">Attachment</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.consultancy_works_carried_out?.map((sponsoredre, index) => {
                  return (
                    <tr key={sponsoredre.id}>
                      <td className="textformat">{sponsoredre?.title}</td>
                      <td className="textformat">{sponsoredre?.sponsored_agency}</td>
                      <td>
                        <table className="table">
                          <tr>
                            <td className='w-8'>{moment(sponsoredre.from_date).format("DD-MM-yyyy")}</td>
                            <td className='w-8'>{moment(sponsoredre.to_date).format("DD-MM-yyyy")}</td>
                          </tr>
                        </table>
                      </td>
                      {isOldReportYear &&
                        <>
                          <td>{sponsoredre?.duration}</td>
                          <td className="textformat">{sponsoredre?.research_consultancy}</td>
                        </>
                      }
                      <td className="textformat">{sponsoredre?.pi_or_co_pi}</td>
                      <td>{sponsoredre?.amount}</td>
                      {sponsoredre?.attachment ? (
                        <td>
                          <span
                            className="namelink"
                            onClick={() => {
                              window.open(`${imagepath}${sponsoredre?.attachment}`);
                            }}
                            target="_blank"
                          >
                            View Document
                          </span>
                        </td>
                      ) : (
                        <td>No Data</td>
                      )}
                    </tr>
                  );
                })}
                <tr>
                  <td></td>
                  <td></td>
                  {isOldReportYear && <td></td>}
                  {isOldReportYear && <td></td>}
                  <td></td>
                  <td>Total amount of grant</td>
                  <td>{appliedReport?.total_amount_for_consultancy_works_carried_out}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.research_publications?.length > 0 && (
        <div>
          <h6 className="reporttitle">e. Research Publications in referred journals only :</h6>

          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">S.No</th>
                  <th scope="col">Author's (s) in order as appeared</th>
                  <th scope="col">Title</th>
                  <th scope="col">Name of Journal</th>
                  <th scope="col">Volume No</th>
                  <th scope="col">Volume Issue</th>
                  <th scope="col">Year</th>
                  <th scope="col">Listed</th>
                  <th scope="col">Impact Factor</th>
                  <th scope="col">
                    Number of Citations as <br />
                    per Google Scholar
                  </th>
                  <th scope="col">Attachment </th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.research_publications?.map((researchpublic, index) => {
                  return (
                    <tr key={researchpublic.id}>
                      <td key={index}>{index + 1}</td>
                      <td className="textformat">{researchpublic?.author_name}</td>
                      <td className="textformat">{researchpublic?.title}</td>
                      <td className="textformat">{researchpublic?.name_of_journal}</td>
                      <td>{researchpublic?.volume_no}</td>
                      <td>{researchpublic?.volume_issue}</td>
                      <td>{researchpublic?.year}</td>
                      <td className="textformat">{researchpublic?.sci_scopus_ugc}</td>
                      <td className="textformat">{researchpublic?.impact_factor}</td>
                      <td>{researchpublic?.no_of_citations}</td>
                      {researchpublic?.attachment ? (
                        <td>
                          <span
                            className="namelink"
                            onClick={() => {
                              window.open(`${imagepath}${researchpublic?.attachment}`);
                            }}
                            target="_blank"
                          >
                            View Document
                          </span>
                        </td>
                      ) : (
                        <td>No Data</td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.papers_presentation?.length > 0 && (
        <div>
          <h6 className="reporttitle">f. Papers presented in national / international conference/seminar :</h6>

          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">
                    Author (s) Name in order <br />
                    as appeared
                  </th>
                  <th scope="col">Title</th>
                  <th scope="col">
                    Name of the <br /> Conference / Event
                  </th>
                  <th scope="col">ISSN Volume</th>
                  <th scope="col">Page No</th>
                  <th scope="col">Year</th>
                  <th scope="col">Place</th>
                  <th scope="col">Country</th>
                  <th scope="col">Attachment </th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.papers_presentation?.map((paperpresent, index) => {
                  return (
                    <tr key={paperpresent.id}>
                      <td className="textformat">{paperpresent?.author_name}</td>
                      <td className="textformat">{paperpresent?.title}</td>
                      <td className="textformat">{paperpresent?.name_of_the_event}</td>
                      <td>{paperpresent?.issn_volume}</td>
                      <td>{paperpresent?.page_no}</td>
                      <td>{paperpresent?.year}</td>
                      <td className="textformat">{paperpresent?.place}</td>
                      <td className="textformat">{paperpresent?.country}</td>
                      {paperpresent?.attachment ? (
                        <td>
                          <span
                            className="namelink"
                            onClick={() => {
                              window.open(`${imagepath}${paperpresent?.attachment}`);
                            }}
                            target="_blank"
                          >
                            View Document
                          </span>
                        </td>
                      ) : (
                        <td>No Data</td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.books_authored?.length > 0 && (
        <div>
          <h6 className="reporttitle">g. Books authored / Edited book / Edited proceedings / Book chapter / Monographs :</h6>

          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">
                    Author (s) Name in order <br />
                    as appeared
                  </th>
                  <th scope="col">Title</th>
                  <th scope="col">Type of Publications</th>
                  <th scope="col">ISBN / ISSN</th>
                  <th scope="col">Publisher Country</th>
                  <th scope="col">Publisher Year</th>
                  <th scope="col">Total Pages</th>
                  <th scope="col">Attachment </th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.books_authored?.map((books, index) => {
                  return (
                    <tr key={books.id}>
                      <td className="textformat">{books?.author_name}</td>
                      <td className="textformat">{books?.title}</td>
                      <td className="textformat">{books?.type_of_publications}</td>
                      <td className="textformat">{books?.isbn_issn}</td>
                      <td className="textformat">{books?.publisher_country}</td>
                      <td>{books?.publisher_year}</td>
                      <td>{books?.total_pages}</td>
                      {books?.attachment ? (
                        <td>
                          <span
                            className="namelink"
                            onClick={() => {
                              window.open(`${imagepath}${books?.attachment}`);
                            }}
                            target="_blank"
                          >
                            View Document
                          </span>
                        </td>
                      ) : (
                        <td>No Data</td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.patents?.length > 0 && (
        <div>
          <h6 className="reporttitle">h.Patents, copy right and technology transfer agreements signed :</h6>

          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Title</th>
                  <th scope="col">Type</th>
                  <th scope="col">Registration No</th>
                  <th scope="col">Registration Date</th>
                  {!isOldReportYear &&
                    <th scope="col">Level</th>
                  }
                  <th scope="col">Granted / Published</th>
                  <th scope="col">Attachment </th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.patents?.map((patent, index) => {
                  return (
                    <tr key={patent.id}>
                      <td className="textformat">{patent?.title}</td>
                      <td className="textformat">{patent?.type}</td>
                      <td>{patent?.registration_no}</td>
                      <td>{moment(patent?.registration_date).format("DD-MM-yyyy")}</td>
                      {!isOldReportYear && <td>{patent?.level}</td>}
                      <td className="textformat">{patent?.granted_or_filed}</td>
                      {patent?.attachment ? (
                        <td>
                          <span
                            className="namelink"
                            onClick={() => {
                              window.open(`${imagepath}${patent?.attachment}`);
                            }}
                            target="_blank"
                          >
                            View Document
                          </span>
                        </td>
                      ) : (
                        <td>No Data</td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.awards_details?.length > 0 && (
        <div>
          <h6 className="reporttitle">i. Honors / awards / medals/ fellowships for outstanding contributions :</h6>

          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">
                    Name of the Awards / Medals / <br />
                    Fellowships
                  </th>
                  <th scope="col">Awarding Institution</th>
                  <th scope="col">Area of Recognition</th>
                  <th scope="col">National / International</th>
                  <th scope="col">Year</th>
                  <th scope="col">Attachment </th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.awards_details?.map((award, index) => {
                  return (
                    <tr key={award.id}>
                      <td className="textformat">{award?.name_of_the_award}</td>
                      <td className="textformat">{award?.awarding_institution}</td>
                      <td className="textformat">{award?.area_of_recognition}</td>
                      <td className="textformat">{award?.national_or_international}</td>
                      <td>{award?.year}</td>
                      {award?.attachment ? (
                        <td>
                          <span
                            className="namelink"
                            onClick={() => {
                              window.open(`${imagepath}${award?.attachment}`);
                            }}
                            target="_blank"
                          >
                            View Document
                          </span>
                        </td>
                      ) : (
                        <td>No Data</td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {(appliedReport?.administrative_contributions?.length > 0 || appliedReport?.infrastructure_development?.length > 0 || appliedReport?.revenue_generated_through_training_program?.length > 0 || appliedReport?.research_or_academic_events?.length > 0 || appliedReport?.events_conducted?.length > 0 || appliedReport?.new_initiatives?.length > 0) &&
        <p className='text-center mt-5 fw-bold'>INSTITUTIONAL DEVELOPMENT</p>
      }
      {appliedReport?.administrative_contributions?.length > 0 && (
        <div>
          <h6 className="reporttitle">a. Administrative Contributions :</h6>
          <p>
            ((i) Head of Department / centre / Extension Centre; (ii) Chairman / Member of Internal Committees / Board of Studies / Academic Council / Academic Responsibilities; (iii) Warden / CVO / PIO / Nodal Officer / IQAC; <br />
            (iv) In-charge of Maintenance - Civil / Electrical / Networking / Air-condition / Web site / Computer / Vehicle / Security)
          </p>

          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Position</th>
                  {isOldReportYear &&
                    <>
                      <th scope="col">
                        Duration
                        <table className="table">
                          <tr>
                            <td className='w-8'>From</td>
                            <td className='w-8'>To</td>
                          </tr>
                        </table>
                      </th>
                      <th scope="col">Experience (YY-MM)</th>
                    </>
                  }
                  <th scope="col">Significant Contributions</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.administrative_contributions?.map((admincontribute, index) => {
                  return (
                    <tr key={admincontribute.id}>
                      <td className="textformat">{admincontribute?.position}</td>
                      {isOldReportYear &&
                        <>
                          <td>
                            <table className="table">
                              <tr>
                                <td className='w-8'>{moment(admincontribute.from_date).format("DD-MM-yyyy")}</td>
                                <td className='w-8'>{moment(admincontribute.to_date).format("DD-MM-yyyy")}</td>
                              </tr>
                            </table>
                          </td>
                          <td>{admincontribute?.experience}</td>
                        </>
                      }
                      <td className="textformat">{admincontribute?.significant_contributions}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.infrastructure_development?.length > 0 && (
        <div>
          <h6 className="reporttitle">b. Infrastructure development with internal / external funding for improvement in science and technology :</h6>

          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Infrastructure Development</th>
                  <th scope="col">Others</th>
                  <th scope="col">Funding Agency</th>
                  <th scope="col">
                    Duration
                    <table className="table">
                      <tr>
                        <td className='w-8'>From</td>
                        <td className='w-8'>To</td>
                      </tr>
                    </table>
                  </th>
                  <th scope="col">PI or Co-PI</th>
                  <th scope="col">Salient Contributions</th>
                  <th scope="col">
                    Amount of Grant <br /> (Rs. in lakhs)
                  </th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.infrastructure_development?.map((infra, index) => {
                  return (
                    <tr key={infra.id}>
                      <td className="textformat">{infra?.type}</td>
                      <td className="textformat">{infra?.others ? infra?.others : "NA"}</td>
                      <td className="textformat">{infra?.funding_agency}</td>
                      <td>
                        <table className="table">
                          <tr>
                            <td className='w-8'>{moment(infra.from_date).format("DD-MM-yyyy")}</td>
                            <td className='w-8'>{moment(infra.to_date).format("DD-MM-yyyy")}</td>
                          </tr>
                        </table>
                      </td>
                      <td className="textformat">{infra?.pi_or_co_pi}</td>
                      <td className="textformat">{infra?.salient_contributions}</td>
                      <td>{infra?.amount}</td>
                    </tr>
                  );
                })}
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>Total amount of grant</td>
                  <td>{appliedReport?.total_amount_for_infrastructure_development}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
      {isOldReportYear &&
        <>
          {appliedReport?.revenue_generated_through_training_program?.length > 0 && (
            <div>
              <h6 className="reporttitle">c. Revenue generated through Training Programmes as Co-ordinator / Other Avenues :</h6>

              <div className="scroll-table">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th scope="col">Academic Event</th>
                      <th scope="col">Title of Event</th>
                      <th scope="col">National / International</th>
                      <th scope="col">Role</th>
                      <th scope="col">Amount (Rs. in lakhs)</th>
                      <th scope="col">Attachment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {appliedReport?.revenue_generated_through_training_program?.map((revenuegen, index) => {
                      return (
                        <tr key={revenuegen.id}>
                          <td className="textformat">{revenuegen?.academic_event}</td>
                          <td className="textformat">{revenuegen?.title_of_event}</td>
                          <td className="textformat">{revenuegen?.national_or_international}</td>
                          <td className="textformat">{revenuegen?.role}</td>
                          <td>{revenuegen?.amount}</td>
                          {revenuegen?.attachment ? (
                            <td>
                              <span
                                className="namelink"
                                onClick={() => {
                                  window.open(`${imagepath}${revenuegen?.attachment}`);
                                }}
                                target="_blank"
                              >
                                View Document
                              </span>
                            </td>
                          ) : (
                            <td>No Data</td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </>
      }
      {appliedReport?.research_or_academic_events?.length > 0 && (
        <div>
          <h6 className="reporttitle">  {isOldReportYear ? 'd. ' : 'c. '} Research / academic events (workshop / conference / seminar / webinar / programmes under national initiatives) organized at national / international level :</h6>

          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Academic Event</th>
                  <th scope="col">Title of Event</th>
                  <th scope="col">Date</th>
                  <th scope="col">Role</th>
                  <th scope="col">No.of Participants</th>
                  <th scope="col">National / International</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.research_or_academic_events?.map((infra, index) => {
                  return (
                    <tr key={infra.id}>
                      <td className="textformat">{infra?.academic_event}</td>
                      <td className="textformat">{infra?.title_of_event}</td>
                      <td>{moment(infra?.date).format("DD-MM-yyyy")}</td>
                      <td className="textformat">{infra?.role}</td>
                      <td>{infra?.no_of_participants}</td>
                      <td className="textformat">{infra?.national_or_international}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <i># As Organizing Committee Chairname / Secretary / Member / Advisory Committee Member & Others</i>
        </div>
      )}
      {appliedReport?.events_conducted?.length > 0 && (
        <div>
          <h6 className="reporttitle">  {isOldReportYear ? 'e. ' : 'd. '} Events conducted in collaboration with Industry :</h6>

          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Title of Event</th>
                  <th scope="col">Date</th>
                  <th scope="col">Role</th>
                  <th scope="col">No.of Participants</th>
                  <th scope="col">Name of the Industry</th>
                  <th scope="col">Revenue Generated (if applicable)</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.events_conducted?.map((eventconduct, index) => {
                  return (
                    <tr key={eventconduct.id}>
                      <td className="textformat">{eventconduct?.title_of_event}</td>
                      <td>{moment(eventconduct?.date).format("DD-MM-yyyy")}</td>
                      <td className="textformat">{eventconduct?.role}</td>
                      <td>{eventconduct?.no_of_participants}</td>
                      <td className="textformat">{eventconduct?.name_of_the_industry}</td>
                      <td className="textformat">{eventconduct?.revenue_generated}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <i># As Organizing Committee Chairname / Secretary / Member / Advisory Committee Member & Others</i>
        </div>
      )}
      {appliedReport?.new_initiatives?.length > 0 && (
        <div>
          <h6 className="reporttitle">  {isOldReportYear ? 'f. ' : 'e. '} New initiatives implemented for the Institute Development :</h6>

          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Initiative Implemented</th>
                  <th scope="col">Type of Benefit to the Institute</th>
                  <th scope="col">Revenue Generated (if applicable)</th>
                  <th scope="col">Role</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.new_initiatives?.map((newinit, index) => {
                  return (
                    <tr key={newinit.id}>
                      <td className="textformat">{newinit?.initiative_implemented}</td>
                      <td className="textformat">{newinit?.type_of_benefit}</td>
                      <td className="textformat">{newinit?.revenue_generated}</td>
                      <td className="textformat">{newinit?.role}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {(appliedReport?.resource_person_in_training_programmes?.length > 0 || appliedReport?.training_programmes_attended?.length > 0 || appliedReport?.participation_and_academic_contributions?.length > 0 || appliedReport?.overseas_visited_for_academic_events?.length > 0 || appliedReport?.participation_and_contributions?.length > 0 || appliedReport?.editor_in_chief?.length > 0 || appliedReport?.national_or_internatioal_assignment?.length > 0 || appliedReport?.fellow_or_life_member?.length > 0) &&
        <p className='text-center mt-5 fw-bold'>PROFESSIONAL CONTRIBUTIONS</p>
      }

      {appliedReport?.resource_person_in_training_programmes?.length > 0 && (
        <div>
          <h6 className="reporttitle">a. Resource person in Training Programmes / Workshops (External) :</h6>

          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Title of the Program</th>
                  <th scope="col">Mode</th>
                  <th scope="col">Conducted at</th>
                  <th scope="col">
                    Duration
                    <table className="table">
                      <tr>
                        <td className='w-8'>From</td>
                        <td className='w-8'>To</td>
                      </tr>
                    </table>
                  </th>
                  <th scope="col">No.of Hours Handled</th>
                  <th scope="col">Level</th>
                  <th scope="col">Attachment</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.resource_person_in_training_programmes?.map((resourceperson, index) => {
                  return (
                    <tr key={resourceperson.id}>
                      <td className="textformat">{resourceperson?.title}</td>
                      <td className="textformat">{resourceperson?.mode}</td>
                      <td className="textformat">{resourceperson?.conducted_at}</td>
                      <td>
                        <table className="table">
                          <tr>
                            <td className='w-8'>{moment(resourceperson.from_date).format("DD-MM-yyyy")}</td>
                            <td className='w-8'>{moment(resourceperson.to_date).format("DD-MM-yyyy")}</td>
                          </tr>
                        </table>
                      </td>
                      <td>{resourceperson?.no_of_hours}</td>
                      <td className="textformat">{resourceperson?.level}</td>
                      {resourceperson?.attachment ? (
                        <td>
                          <span
                            className="namelink"
                            onClick={() => {
                              window.open(`${imagepath}${resourceperson?.attachment}`);
                            }}
                            target="_blank"
                          >
                            View Document
                          </span>
                        </td>
                      ) : (
                        <td>No Data</td>
                      )}
                    </tr>
                  );
                })}
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>Total numbers of hours handled</td>
                  <td>{appliedReport?.total_no_of_hours_for_resource_person_in_training_programmes}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.training_programmes_attended?.length > 0 && (
        <div>
          <h6 className="reporttitle">b. Training programmes attended :</h6>

          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Title of the Training</th>
                  <th scope="col">Host Institution</th>
                  <th scope="col">Sponsoring Agency</th>
                  <th scope="col">
                    Duration
                    <table className="table">
                      <tr>
                        <td className='w-8'>From</td>
                        <td className='w-8'>To</td>
                      </tr>
                    </table>
                  </th>
                  <th scope="col">Level</th>
                  <th scope="col">Attachment</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.training_programmes_attended?.map((resourceperson, index) => {
                  return (
                    <tr key={resourceperson.id}>
                      <td className="textformat">{resourceperson?.title}</td>
                      <td className="textformat">{resourceperson?.host_institution}</td>
                      <td className="textformat">{resourceperson?.sponsoring_agency}</td>
                      <td>
                        <table className="table">
                          <tr>
                            <td className='w-8'>{moment(resourceperson.from_date).format("DD-MM-yyyy")}</td>
                            <td className='w-8'>{moment(resourceperson.to_date).format("DD-MM-yyyy")}</td>
                          </tr>
                        </table>
                      </td>
                      <td className="textformat">{resourceperson?.national_or_international}</td>
                      {resourceperson?.attachment ? (
                        <td>
                          <span
                            className="namelink"
                            onClick={() => {
                              window.open(`${imagepath}${resourceperson?.attachment}`);
                            }}
                            target="_blank"
                          >
                            View Document
                          </span>
                        </td>
                      ) : (
                        <td>No Data</td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.participation_and_academic_contributions?.length > 0 && (
        <div>
          <h6 className="reporttitle">c. Participation and academic contributions in the area of your professional expertise at <br />State / National/ International Level :</h6>

          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Assignment</th>
                  <th scope="col">Organization</th>
                  <th scope="col">Nature of Duty</th>
                  <th scope="col">
                    Duration
                    <table className="table">
                      <tr>
                        <td className='w-8'>From</td>
                        <td className='w-8'>To</td>
                      </tr>
                    </table>
                  </th>
                  {isOldReportYear && <th scope="col">Experience (YY-MM)</th>}
                  <th scope="col">Level</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.participation_and_academic_contributions?.map((participat, index) => {
                  return (
                    <tr key={participat.id}>
                      <td className="textformat">{participat?.assignment}</td>
                      <td className="textformat">{participat?.organization}</td>
                      <td className="textformat">{participat?.nature_of_duty}</td>
                      <td>
                        <table className="table">
                          <tr>
                            <td>{moment(participat.from_date).format("DD-MM-yyyy")}</td>
                            <td>{moment(participat.to_date).format("DD-MM-yyyy")}</td>
                          </tr>
                        </table>
                      </td>
                      {isOldReportYear &&
                        <td>{participat?.experience}</td>
                      }
                      <td className="textformat">{participat?.level}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <p>
            Chairman / Member in board of studies / academic councils / executive committees
            <br /> *MOOC / NRC / CDTP / Others <br /> # Invited lectures : Question paper setting & evaluator; Thesis examiner; Screening / Assessment / Selection Committee Member Chairing / Co-chairing / rapporteur in conference / seminar / workshop;Accreditation; and Paricipated meetings of AICTE / MoE / MEA / BoG; Any other external agencies
          </p>
        </div>
      )}
      {appliedReport?.overseas_visited_for_academic_events?.length > 0 && (
        <div>
          <h6 className="reporttitle">d. Overseas visited for Academic Events / Plenary Lectures / Invited Talks / part of Delegation / Others :</h6>
          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Organization / University Visited</th>
                  <th scope="col">City Visited</th>
                  <th scope="col">Country Visited</th>
                  <th scope="col">Institution Sponsored the visit</th>
                  <th scope="col">nature of Visit</th>
                  <th scope="col">
                    Duration
                    <table className="table">
                      <tr>
                        <td className='w-8'>From</td>
                        <td className='w-8'>To</td>
                        {isOldReportYear && <td>YY-MM</td>}
                      </tr>
                    </table>
                  </th>
                  <th scope="col">Attachment</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.overseas_visited_for_academic_events?.map((overseas, index) => {
                  return (
                    <tr key={overseas.id}>
                      <td className="textformat">{overseas?.organization_or_university}</td>
                      <td className="textformat">{overseas?.city}</td>
                      <td className="textformat">{overseas?.country}</td>
                      <td className="textformat">{overseas?.institution_sponsored}</td>
                      <td className="textformat">{overseas?.nature_of_visit}</td>
                      <td>
                        <table className="table">
                          <tr>
                            <td className='w-8'>{moment(overseas.from_date).format("DD-MM-yyyy")}</td>
                            <td className='w-8'>{moment(overseas.to_date).format("DD-MM-yyyy")}</td>
                            {isOldReportYear && <td>{overseas.duration}</td>}
                          </tr>
                        </table>
                      </td>
                      {overseas?.attachment ? (
                        <td>
                          <span
                            className="namelink"
                            onClick={() => {
                              window.open(`${imagepath}${overseas?.attachment}`);
                            }}
                            target="_blank"
                          >
                            View Document
                          </span>
                        </td>
                      ) : (
                        <td>No Data</td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.participation_and_contributions?.length > 0 && (
        <div>
          <h6 className="reporttitle">e. Participation and contributions in the area of your academic and professional expertise :</h6>

          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Details</th>
                  <th scope="col">
                    Duration
                    <table className="table">
                      <tr>
                        <td className='w-8'>From</td>
                        <td className='w-8'>To</td>
                        {isOldReportYear && <td className='w-8'>YY-MM</td>}
                      </tr>
                    </table>
                  </th>
                  <th scope="col">Attachment</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.participation_and_contributions?.map((parti, index) => {
                  return (
                    <tr key={parti.id}>
                      <td className="textformat">{parti?.details}</td>
                      <td>
                        <table className="table">
                          <tr>
                            <td className='w-8'>{moment(parti.from_date).format("DD-MM-yyyy")}</td>
                            <td className='w-8'>{moment(parti.to_date).format("DD-MM-yyyy")}</td>
                            {isOldReportYear && <td className='w-8'>{parti.duration}</td>}
                          </tr>
                        </table>
                      </td>
                      {parti?.attachment ? (
                        <td>
                          <span
                            className="namelink"
                            onClick={() => {
                              window.open(`${imagepath}${parti?.attachment}`);
                            }}
                            target="_blank"
                          >
                            View Document
                          </span>
                        </td>
                      ) : (
                        <td>No Data</td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.editor_in_chief?.length > 0 && (
        <div>
          <h6 className="reporttitle">f. Editor-in-chief / Editorial Board Member / Peer Reviewer / Others :</h6>

          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Role</th>
                  <th scope="col">Title of Journal</th>
                  <th scope="col">Journal Publisher</th>
                  <th scope="col">ISSN</th>
                  <th scope="col">Duration (Year)</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.editor_in_chief?.map((edit, index) => {
                  return (
                    <tr key={edit.id}>
                      <td className="textformat">{edit?.role}</td>
                      <td className="textformat">{edit?.title_of_journal}</td>
                      <td className="textformat">{edit?.journal_publisher}</td>
                      <td className="textformat">{edit?.issn}</td>
                      <td>{edit?.year}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.national_or_internatioal_assignment?.length > 0 && (
        <div>
          <h6 className="reporttitle">g. National / International academic assignment for more than 1 year (Full-time) :</h6>

          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Post / Assignment</th>
                  <th scope="col">
                    National / International <br />
                    Organization / University
                  </th>
                  <th scope="col">Nature of Assignment</th>
                  <th scope="col">
                    Duration
                    <table className="table">
                      <tr>
                        <td className='w-8'>From</td>
                        <td className='w-8'>To</td>
                        <td className='w-8'>YY-MM</td>
                      </tr>
                    </table>
                  </th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.national_or_internatioal_assignment?.map((nationalassign, index) => {
                  return (
                    <tr key={nationalassign.id}>
                      <td className="textformat">{nationalassign?.type}</td>
                      <td className="textformat">{nationalassign?.level}</td>
                      <td className="textformat">{nationalassign?.nature_of_assignment}</td>
                      <td>
                        <table className="table">
                          <tr>
                            <td className='w-8'>{moment(nationalassign.from_date).format("DD-MM-yyyy")}</td>
                            <td className='w-8'>{moment(nationalassign.to_date).format("DD-MM-yyyy")}</td>
                            <td className='w-8'>{nationalassign.duration}</td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {appliedReport?.fellow_or_life_member?.length > 0 && (
        <div>
          <h6 className="reporttitle">h. Fellow / Life Member / Member of Professional Bodies / Societies :</h6>

          <div className="scroll-table">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Name of the Professional Bodies / Societies</th>
                  <th scope="col">Fellow / Life Member / Member</th>
                  <th scope="col">National / International</th>
                  <th scope="col">Registration No</th>
                  <th scope="col">Registration Year</th>
                </tr>
              </thead>
              <tbody>
                {appliedReport?.fellow_or_life_member?.map((fellow, index) => {
                  return (
                    <tr key={fellow.id}>
                      <td className="textformat">{fellow?.name}</td>
                      <td className="textformat">{fellow?.type}</td>
                      <td className="textformat">{fellow?.level}</td>
                      <td>{fellow?.registration_no}</td>
                      <td>{fellow?.registration_year}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  )
}

export default OverallReport